// extracted by mini-css-extract-plugin
export default {"recentSearchesHeader":"e4Z6dn2 sY3mB1c london3-button","recentSearchesClearButton":"usXxuqe rhsKrX3 sY3mB1c london3-button"};